import initNavigation from "components/masthead/helpers/init_navigation";

import "./component.scss";

export default initNavigation({
  navigationLinksSelector: ".js-masthead-shirts-navigation-link",
  navigationContentSelector: ".js-masthead-shirts-navigation-content",
  detailsContentSelector: ".js-masthead-shirts-navigation-details-container",
  activeLinkClassName: "masthead-shirts-navigation__section--active"
});
